/**
 * @Author: v_jppjpeng
 * @Date: 2023-02-01 16:43:47
 * @Explain: 菜单
 */

import classNames from 'classnames';
import { useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'umi';
// router
import routingPath from '@/router/routingPath';
// utils
import { doesItExist } from '@/utils/common/dataJudgment';
// type
import type { RoleJudgmentType } from '@/api/common/data.d';
import type { ConnectState } from '@/models/connect.d';

import MenuItem from './menuItem';

type PropsType = {
  isCollapse?: boolean;
  list: any[];
  currentPathName: string;
  rolesJson: RoleJudgmentType;
  getAuth: (val: string) => boolean;
  onClickItem?: (data: any) => void;
};
// 待审批菜单项目 类名
export const APPROVAL_BADGE_CLASS_NAME = 'approval-badge';

// 消息推送: 控制待审批菜单是否显示待审批数量
export const controlApprovalBadge = ({
  allApprovalNumber,
}: {
  allApprovalNumber: number;
}) => {
  // 监听获取待审批菜单指定类名menu-children-item-pushApproval 的dom 元素
  const pushApprovalItem = document.querySelector(
    '.menu-children-item-pushApproval',
  );
  // 无消息推送审核菜单在则直接返回
  if (!pushApprovalItem) {
    return;
  }

  // 先查是否存在同类名(APPROVAL_BADGE_CLASS_NAME)dom
  const badge = pushApprovalItem.querySelector(`.${APPROVAL_BADGE_CLASS_NAME}`);

  // 值不存 或 0 移除待审批数量标签
  if (!allApprovalNumber) {
    badge?.remove();
    return;
  }

  // 若是存在则直接更改标签内展示值
  if (badge) {
    badge.textContent = `${allApprovalNumber}`;
  } else {
    // 若是不存在则创建dom设置值
    const newBadege = document.createElement('span');
    newBadege.className = APPROVAL_BADGE_CLASS_NAME;
    newBadege.textContent = `${allApprovalNumber}`;
    pushApprovalItem.appendChild(newBadege);
  }
};

export default function MenuCollapse(props: PropsType) {
  const { isCollapse, list, currentPathName, rolesJson, getAuth, onClickItem } =
    props;
  const { pendingApprovalData } = useSelector(
    (state: ConnectState) => state.PushNotificationModel,
  );
  const isViewer = useMemo(() => rolesJson.isViewer, [rolesJson.isViewer]);

  // demo 项目需要展示的菜单
  const isDemoShow = useCallback(
    (path: string) => {
      let flag = true;
      const showArr = [
        routingPath.HOME,
        routingPath.ACTIVITY_MANAGE_LIST,
        routingPath.ACTIVITY_CYCLE_LIST,
        routingPath.ACTIVITY_AB_TEST_LIST,
        routingPath.ACTIVITY_AUTO_LIST,
        routingPath.CONTACT_REPORT,
        routingPath.SEGMENTS_MANAGE_LIST,
        routingPath.LABEL_MANAGE_LIST,
        routingPath.SIGN_UP_FORM_LIST,
        routingPath.PREFERENCE_MANAGE_SETTING,
        routingPath.MAIL_TEMPLATE_MARKETING_LIST,
        routingPath.MAIL_TEMPLATE_TRANSACTIONAL_LIST,
        routingPath.PLACEHOLDER_MANAGE_LIST,
        routingPath.ACTIVITY_REPORT_LIST,
      ];
      if (isViewer && path) {
        flag = showArr.includes(path);
      }
      return flag;
    },
    [isViewer],
  );

  // 消息推送 待审批菜单显示待审批数量
  useEffect(() => {
    controlApprovalBadge({
      allApprovalNumber: pendingApprovalData?.allApprovalNumber || 0,
    });
  }, [pendingApprovalData.allApprovalNumber, controlApprovalBadge]);
  return (
    <div
      className={classNames('menu-collapse', { 'is-collapse': isCollapse })}
      style={{ height: isCollapse ? 'auto' : 0 }}
    >
      <div className="menu-children">
        {list.map((item, index) => {
          const selected = currentPathName
            ? item?.urls?.some((url: string) =>
                doesItExist(url, currentPathName),
              )
            : false;
          return getAuth(item.to) && isDemoShow(item.to) ? (
            <MenuItem
              key={`menu-children-item-${index}`}
              icon="triangle-right-arrow"
              className={`menu-children-item-${item.urlIncludes}`}
              selected={selected}
              titleKey={item.titleKey}
              onClick={() => onClickItem?.(item)}
            />
          ) : (
            ''
          );
        })}
      </div>
    </div>
  );
}
